// extracted by mini-css-extract-plugin
export default {"notFound":"Notfound_notFound__Kgr8J","btnGroup":"Notfound_btnGroup__JOd8w"};